import { useRef, useState } from 'react';
import { validationService } from '../../services/validationService';
import './styles.scss';
import { InputType } from '../../modules/authorization/authorization.type';
import { ImgImporter } from '../imgImporter';
import { initAuthErrorList } from '../../helpers/initAuthErrorList';
import cn from 'classnames';
import { passwordValidSteps } from './constants';

type AuthInputProps = {
  input: InputType;
  onChange: Function;
  value?: string;
  typeofSection?: string;
};

export const AuthInput: React.FC<AuthInputProps> = ({
  input,
  onChange,
  value = '',
  typeofSection = '',
}) => {
  const { id, label, placeholder, type, disabled, validation, name } = input;
  const [inputType, setinputType] = useState<string>(type);
  const [inputValue, setInputValue] = useState<string>(value);
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [validationsForPass, setValidationsForPass] = useState<{
    [key: string]: boolean;
  }>();

  const container = document.querySelector('.popupContainerInner');
  const popupRef = useRef<HTMLDivElement | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValidationsForPass(validationService.validationByStep(newValue));
    setInputValue(newValue);

    onChange(
      name,
      newValue,
      validationService[
        `${validation.type}Validation` as keyof typeof validationService
      ](newValue),
      initAuthErrorList[name],
    );
  };

  const handleFocused = (status: boolean) => {
    if (validation?.type !== 'password') return;
    setIsFocused(status);
    if (popupRef.current && container) {
      const popupRect = popupRef.current.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      const isOverflow = popupRect.top < containerRect.top;

      setIsOverflowing(isOverflow);
    }
  };

  const handleBlur = () => {
    handleFocused(false);
    setIsOverflowing(false);
  };

  const changeInputType = () => {
    inputType !== 'text' ? setinputType('text') : setinputType('password');
  };

  const inputPreventDefault = (e: any) => {
    if (typeofSection === 'registration') e.preventDefault();
  };

  const isFieldPassword = (field: string) => {
    return (
      field === 'password' ||
      field === 'new-password' ||
      field === 'confirm-password'
    );
  };

  return (
    <div className="authInputWrp">
      <label className="authInputText" htmlFor={String(id)}>
        {label}
      </label>
      <div
        className={cn('authInputCase', 'lg', {
          error: !!inputValue.length && validation.status === false,
          disabled,
        })}
      >
        <input
          onPaste={inputPreventDefault}
          onDrop={inputPreventDefault}
          value={inputValue}
          className={`authInput ${isFieldPassword(inputType) ? 'pass' : ''}`}
          id={String(id)}
          type={inputType}
          placeholder={placeholder}
          disabled={disabled}
          onChange={handleChange}
          onFocus={() => handleFocused(true)}
          onBlur={() => handleBlur()}
          tabIndex={input.tabIndex}
        />
        {isFieldPassword(type) && (
          <div className="authInputIconCase" onClick={changeInputType}>
            {isFieldPassword(inputType) ? (
              <i className="icon-eye-opened" />
            ) : (
                <i className="icon-eye-closed" />
            )}
          </div>
        )}
      </div>
      {validation.status === false &&
        !!validation.error &&
        !!inputValue.length && <p className="errorText">{validation.error}</p>}

      {isFocused && (
        <div
          className={cn('registerSmallPopup', {
            focused: true,
            underInput: isOverflowing,
          })}
          ref={popupRef}
        >
          <div className="registerSmallPopupHolder">
            <div className="registerSmallPopupInner">
              {passwordValidSteps.map(
                (el: { id: number; validType: string; text: string }) => (
                  <div key={el.id} className="smallPopupRow">
                    <div className="checkBoxHolder">
                      <div
                        className={cn('PopupCheckBox', {
                          checked: validationsForPass?.[el.validType],
                        })}
                      />
                      <div className="checkBoxCont">
                        <i className="checkBoxPopupIcon icon-check" />
                      </div>
                    </div>
                    <p className="smallPopupText">{el.text}</p>
                  </div>
                ),
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
